import type { UpdateVacationResponse } from '@lunya/contracts'
import { API_PATHS } from '@lunya/contracts'

import { copy } from '~/modules/lunya'
import { createMutation, optimisticUpdate } from '~/shared/api'
import { notifications } from '~/shared/lib/notifications'

import { endOfIsoDate, toIsoDate } from '../utils'
import { mapUserFromApi } from './mappers/mapUserFromApi'
import { mapVacationToApi, type UpdateVacationInput } from './mappers/mapVacationToApi'
import { UserQuery } from './UserQuery'

export type { UpdateVacationInput }

/** PATCH /users/me/vacation — включение/выключение режима «Я в отпуске» (спека 07 §2.2). */
export const UpdateVacationMutation = createMutation<
  UpdateVacationInput,
  UpdateVacationResponse,
  ReturnType<typeof mapUserFromApi>
>({
  key: 'user.updateVacation',
  path: API_PATHS.user.vacation,
  method: 'PATCH',
  getBody: mapVacationToApi,
  transform: mapUserFromApi,
  // Выключение отпуска — один тап по тумблеру, ждать ответа он не должен. Дату прогоняем через
  // ту же пару `toIsoDate`/`endOfIsoDate`, что и ручка с маппером: иначе оптимистичное значение
  // отличалось бы от приехавшего с сервера на без малого сутки и карточка моргала бы датой.
  optimistic: [
    optimisticUpdate(UserQuery, (user, input: UpdateVacationInput) => ({
      ...user,
      vacationUntil: input.until ? endOfIsoDate(toIsoDate(input.until)) : null,
    })),
  ],
  sideEffects: {
    invalidateQueries: [UserQuery],
    onAnyError: () => notifications.error(copy.profile.save_error),
  },
})
